<template>
  <Layout>
    <div class="batch-detail">
      <q-btn @click="$router.push('/manheim-batch')" color="primary" class="q-mb-sm">Back</q-btn>
      <q-card class="batch-card">
        <q-list>
          <q-item>
            <q-item-section>
              <span class="batch-title">Region</span>
            </q-item-section>
            <q-item-section>
              {{ batch.region }}
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <span class="batch-title">Status</span>
            </q-item-section>
            <q-item-section>
              {{ batch.status }}
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <span class="batch-main-title">Results</span>
            </q-item-section>
          </q-item>
          <q-item v-if="batch.results">
            <q-list style="width: 100%">
              <q-item>
                <q-item-section>
                  <span class="batch-title">Message</span>
                </q-item-section>
                <q-item-section>
                  {{ batch.results.message }}
                </q-item-section>
              </q-item>
              <q-item v-if="batch.type === 'create' && batch.results.updated_items">
                <q-item-section style="justify-content: start !important">
                  <span class="batch-title">Updated Items</span>
                </q-item-section>
                <q-item-section style="justify-content: start !important">
                  <ul style="list-style-type: none; margin: 0; padding: 0">
                    <li v-for="(item, index) in batch.results.updated_items" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </q-item-section>
              </q-item>
              <q-item v-if="batch.type === 'delete' && batch.results.deleted_items">
                <q-item-section style="justify-content: start !important">
                  <span class="batch-title">Deleted Items</span>
                </q-item-section>
                <q-item-section style="justify-content: start !important">
                  <ul style="list-style-type: none; margin: 0; padding: 0">
                    <li v-for="(item, index) in batch.results.deleted_items" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </q-item-section>
              </q-item>
              <q-item v-if="batch.results.errors">
                <q-item-section style="justify-content: start !important">
                  <span class="batch-title">Errors</span>
                </q-item-section>
                <q-item-section style="justify-content: start !important">
                  <ul style="list-style-type: none; margin: 0; padding: 0">
                    <li class="d-flex align-items-center" v-for="(item, index) in batch.results.errors" :key="index">
                      <span style="font-weight: bold; margin-right: 10px; font-size: 12px">
                        {{ Object.keys(item)[0] }} :</span
                      >
                      <span style="font-size: 12px"> {{ Object.values(item)[0] }} </span>
                    </li>
                  </ul>
                </q-item-section>
              </q-item>
            </q-list>
          </q-item>
          <q-item>
            <q-item-section>
              <span class="batch-title">Created at</span>
            </q-item-section>
            <q-item-section>
              {{ batch.created_at | dateTimeFormat }}
            </q-item-section>
          </q-item>
        </q-list>
      </q-card>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/Layout'
import axios from '../axios/index'

export default {
  components: {
    Layout
  },
  data() {
    return {
      batch: {}
    }
  },
  async created() {
    await this.getBatch()
  },
  methods: {
    async getBatch() {
      try {
        const { data } = await axios.get('/queries/manheim/batch/' + this.$route.params.id)
        this.batch = data.data
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>
.batch-detail {
  padding: 0;
  width: 100%;
  text-transform: capitalize;
}
.batch-card {
  margin: 0 auto;
}
.batch-main-title {
  font-size: 1.2em;
  font-weight: bold;
}
.batch-title {
  font-weight: bold;
}
.q-item {
  padding: 4px 6px;
}
</style>
